import { ConstelaConfigurationModule } from '../../../types/ConstelaConfiguration'
import {
  modifyGlobalProperties,
  modifyModuleProperties,
  setConfigurationModules
} from '../../model/ConstelaConfiguration'
import { AsyncAction } from '../types'
import { ConfigurationSetModulesAction, ConfigurationSetPropertiesAction } from '../types/configurationTypes'

export const reorderArray = <T>(array: T[], insert: T, from: number | undefined, to: number | undefined): T[] => {
  const result = [...array]
  let _insert = insert
  if (typeof from === 'number') {
    _insert = result.splice(from, 1)[0]
  }
  if (typeof to === 'number') {
    result.splice(to, 0, _insert)
  }
  return result
}

export const setModulesAction = (
  location: { mode: 'expert' } | { mode: 'inspiration'; applicationId: string },
  modules: ConstelaConfigurationModule[]
): AsyncAction<ConfigurationSetModulesAction> => (dispatch, getState) => {
  const configuration =
    location.mode === 'expert'
      ? getState().configuration.expertMode
      : getState().configuration.inspirationMode[location.applicationId]
  const nextConfiguration = setConfigurationModules(configuration, modules, getState().data)
  dispatch({
    type: 'Configuration/SetModules',
    ...location,
    modules: nextConfiguration.modules
  })
}

export const setExpertPropertiesAction = (
  module: 'global' | number,
  properties: Record<string, string>
): AsyncAction<ConfigurationSetPropertiesAction> => (dispatch, getState) => {
  if (module !== 'global') {
    const nextConfiguration = modifyModuleProperties(
      getState().configuration.expertMode,
      module,
      properties,
      getState().data
    )

    if (nextConfiguration) {
      dispatch({
        type: 'Configuration/SetProperties',
        mode: 'expert',
        module,
        properties: nextConfiguration.modules[module].properties
      })
    }
  } else {
    const nextConfiguration = modifyGlobalProperties(getState().configuration.expertMode, properties, getState().data)

    dispatch({
      type: 'Configuration/SetProperties',
      mode: 'expert',
      module: 'global',
      properties: nextConfiguration.properties,
      modules: nextConfiguration.modules
    })
  }
}
